import React from 'react';

interface IProps {
  className?: string;
  onClick?: () => void;
}

function Icon(props: IProps): JSX.Element {
  return <div {...props}>
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.187 0.344084L16.4059 1.96762C16.6698 2.31947 17.1549 2.41497 17.5318 2.1913L19.2785 1.15837C19.7711 0.866833 20.407 1.13072 20.5502 1.68614L21.0554 3.65148C21.1634 4.07621 21.5756 4.35266 22.0104 4.28983L24.021 4.00333C24.589 3.9229 25.0765 4.40795 24.9936 4.97594L24.7071 6.98651C24.6442 7.4213 24.9207 7.83347 25.3454 7.94154L27.3108 8.44669C27.8662 8.58995 28.1301 9.22579 27.8385 9.71838L26.8056 11.4651C26.5819 11.842 26.6774 12.3296 27.0293 12.591L28.6528 13.8099C29.1127 14.1542 29.1127 14.8428 28.6528 15.1871L27.0293 16.406C26.6774 16.6699 26.5819 17.155 26.8056 17.532L27.8385 19.2787C28.1301 19.7712 27.8662 20.4071 27.3108 20.5503L25.3454 21.0555C24.9207 21.1636 24.6442 21.5757 24.7071 22.0105L24.9936 24.0211C25.074 24.5891 24.589 25.0766 24.021 24.9937L22.0104 24.7072C21.5756 24.6444 21.1634 24.9208 21.0554 25.3456L20.5502 27.3109C20.407 27.8663 19.7711 28.1302 19.2785 27.8387L17.5318 26.8057C17.1549 26.5821 16.6673 26.6776 16.4059 27.0294L15.187 28.653C14.8427 29.1129 14.1541 29.1129 13.8098 28.653L12.5909 27.0294C12.327 26.6776 11.8419 26.5821 11.4649 26.8057L9.71826 27.8387C9.22567 28.1302 8.58982 27.8663 8.44657 27.3109L7.94141 25.3456C7.83335 24.9208 7.42118 24.6444 6.98639 24.7072L4.97582 24.9937C4.40783 25.0741 3.92027 24.5891 4.0032 24.0211L4.28971 22.0105C4.35254 21.5757 4.07609 21.1636 3.65135 21.0555L1.68602 20.5503C1.1306 20.4071 0.866711 19.7712 1.15824 19.2787L2.19118 17.532C2.41485 17.155 2.31935 16.6674 1.9675 16.406L0.343962 15.1871C-0.115956 14.8428 -0.115956 14.1542 0.343962 13.8099L1.9675 12.591C2.31935 12.3271 2.41485 11.842 2.19118 11.4651L1.15824 9.71838C0.866711 9.22579 1.1306 8.58995 1.68602 8.44669L3.65135 7.94154C4.07609 7.83347 4.35254 7.4213 4.28971 6.98651L4.0032 4.97594C3.92278 4.40795 4.40783 3.92039 4.97582 4.00333L6.98639 4.28983C7.42118 4.35266 7.83335 4.07621 7.94141 3.65148L8.44657 1.68614C8.58982 1.13072 9.22567 0.866833 9.71826 1.15837L11.4649 2.1913C11.8419 2.41497 12.3295 2.31947 12.5909 1.96762L13.8098 0.344084C14.1541 -0.115834 14.8427 -0.115834 15.187 0.344084Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M12.3564 20.4706L7 15.1773L8.95781 13.2416L12.3564 16.6018L20.0449 9L22 10.9357L12.3564 20.4706Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="4.24646"
          y1="4.24658"
          x2="24.7519"
          y2="24.752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9B5EFF" />
          <stop offset="1" stopColor="#1E1A8D" />
        </linearGradient>
      </defs>
    </svg>
  </div>
}

export default Icon;
